import React, { useEffect, useState } from 'react';
import { Box, TextField, withStyles } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ReportApi from '../../../api/ReportApi';
import { filters } from './styles';

function ClientsFilter({ classes, label, handleFilterChange, filters }) {
    const [items, setItems] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetch = async () => {
            setLoading(true);

            const clients = await ReportApi.getClients();

            setItems(
                clients.customers.map(client => ({
                    label: `${client.title} ${client.firstName} ${client.surname}`,
                    value: client.id
                }))
            );

            setLoading(false);
        };

        fetch();
    }, []);

    useEffect(() => {
        if (items.length > 0) {
            const value = filters['clients'];
            if (value) {
                const splitted_values = value.split(',');
                setSelectedItems(splitted_values.map(sv => items.find(s => s.value === sv)));
            }
        }
    }, [filters, items]);

    const handleChange = (_, items) => {
        const _items = items.map(i => i.value).join(',');
        handleFilterChange({
            clients: _items
        });
        setSelectedItems(items);
    };

    return (
        <Box marginTop={4}>
            <Autocomplete
                multiple
                className={classes.autocomplete}
                options={items}
                value={selectedItems}
                onChange={handleChange}
                loading={loading}
                label={label}
                getOptionLabel={option => option.label}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={label}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            classes: {
                                input: classes.autocompleteInputProps
                            }
                        }}
                        InputLabelProps={{
                            ...params.InputLabelProps,
                            className: classes.autocompleteLabelProps
                        }}
                    />
                )}
                renderOption={option => {
                    return <p className={classes.autocompleteOptions}>{`${option.label}`}</p>;
                }}
                ChipProps={{ className: classes.autocompleteChipProps }}
            />
        </Box>
    );
}

export default withStyles(filters)(ClientsFilter);
